<template>
	<v-dialog v-model="showDialog" max-width="600px" persistent>
		<v-card>
			<v-card-title>
				<span class="text-h5"> DbConnection </span>
			</v-card-title>
			<v-card-text>
				<v-container>
					<v-form ref="form">
						<v-row>
							<v-col>
								<v-text-field
									v-model="formDbConnection.SqlServerName"
									name="sqlservername"
									label="SQL Server Name"
									:rules="sqlServerNameRules"
									required
								/>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-text-field
									v-model="formDbConnection.DatabaseName"
									name="databasename"
									label="Database Name"
									:rules="databaseNameRules"
									required
								/>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-select
									v-model="loginMethod"
									:items="loginItems"
									item-text="text"
									item-value="id"
									name="LoginMethod"
									label="LoginMethod"
									:rules="loginMethodRules"
									required
								/>
							</v-col>
						</v-row>
						<v-row v-if="loginMethod == loginItems[0].id">
							<v-col>
								<v-text-field
									v-model="formDbConnection.SqlUserName"
									name="SqlUserName"
									label="SQL UserName"
									required
								/>
							</v-col>
						</v-row>
						<v-row v-if="loginMethod == loginItems[0].id">
							<v-col>
								<v-text-field
									v-model="formDbConnection.SqlPassword"
									:append-icon="
										show ? 'mdi-eye' : 'mdi-eye-off'
									"
									:type="show ? 'text' : 'password'"
									@click:append="togglePassVisibility"
									name="sqlPassword"
									label="SQL Password"
									required
								/>
							</v-col>
						</v-row>
					</v-form>
				</v-container>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn text outlined @click="onCancel()"> Cancel </v-btn>
				<v-btn color="primary" @click="onSave()">
					<v-icon class="mr-2">mdi-content-save</v-icon>
					Submit
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { SqlLoginMethod } from '../../enums/sqlLoginMethod';
export default {
	name: 'DbConnection',
	props: {
		showDialog: Boolean,
		dbConnection: Object,
	},
	data() {
		return {
			show: false,
			loginItems: [
				{ id: SqlLoginMethod.SqlLogin, text: 'SQL Login' },
				{
					id: SqlLoginMethod.WindowsAuthentication,
					text: 'Windows Authentication',
				},
			],

			sqlServerNameRules: [(v) => !!v || 'Sql Server Name is required'],
			databaseNameRules: [
				(v) => !!v || 'Database Name is required',
				(value) => {
					const pattern = /^[A-Za-z_][A-Za-z0-9_][^\s]*$/;
					return (
						pattern.test(value) || 'Invalid database name format'
					);
				},
			],

			loginMethodRules: [(v) => !!v || 'Login Method must be selected'],
			loginMethod: null,
		};
	},
	mounted() {
		this.loginMethod = this.formLoginMethod;
	},
	computed: {
		formDbConnection() {
			let item = {};
			if (this.dbConnection) {
				item = this.dbConnection;
			}
			return Object.assign({}, item);
		},
		formLoginMethod() {
			if (this.dbConnection && this.dbConnection.LoginMethod) {
				return this.loginItems.find(
					(x) => x.id == this.dbConnection.LoginMethod
				).id;
			}
			return null;
		},
	},
	methods: {
		onSave() {
			if (this.$refs.form.validate()) {
				this.formDbConnection.LoginMethod = this.loginMethod;
				this.$emit('save', this.formDbConnection);
			}
		},
		togglePassVisibility() {
			this.show = !this.show;
		},
		onCancel() {
			this.$emit('cancel');
		},
	},
};
</script>
